/*
  "Voeg toe" on the product cards (snippets/product-tab-card.liquid), home collection tabs and
  article products. Adds the monthly subscription the card shows (data-selling-plan-id), or the
  one-time product when a product has no plan. Trimester bundles are links, not buttons.
*/
(function () {
  if (window.rkCardAdd) return;
  window.rkCardAdd = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button.addt-to-cart');
    if (!button) return;
    event.preventDefault();

    var variantId = parseInt(button.dataset.variantId, 10);
    var cartDrawer = document.querySelector('cart-drawer');
    if (!variantId || !cartDrawer) {
      window.location.href = '/cart';
      return;
    }

    var item = { id: variantId, quantity: 1 };
    if (button.dataset.sellingPlanId) item.selling_plan = parseInt(button.dataset.sellingPlanId, 10);

    button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add product to cart');
        return response.json();
      })
      .then(function () {
        if (typeof cartDrawer.renderContents === 'function') cartDrawer.renderContents({ id: variantId });
        else window.location.href = '/cart';
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        button.disabled = false;
      });
  });
})();
